import type { Conditions, View } from "../../common/types.ts";
import { PLAYER_STATS_TABLES } from "../../common/constants.ts";
import playerStats from "../views/playerStats.ts";

// Reuse the current view's filtering/aggregation, including historical teams,
// watch lists, career totals, and the remaining playoff teams.
export const getPlayerStatsClipboardData = async (
	{ abbrev, season }: Pick<View<"playerStats">, "abbrev" | "season">,
	conditions: Conditions,
) => {
	const tables = __SPORT === "basketball" ? ["perGame", "shotLocations", "advanced", "gameHighs"] : Object.keys(PLAYER_STATS_TABLES);
	const sections = [];
	for (const statType of tables) {
		for (const playoffs of ["regularSeason", "playoffs"] as const) {
			const data = await playerStats.load({
				inputs: { abbrev, season, statType, playoffs },
				updateEvents: new Set(["firstRun"]),
				prevInputs: undefined,
				prevOutput: {},
				conditions,
			});
			if (data && data.players.length > 0) sections.push(data);
		}
	}
	return sections;
};
